import { Loader } from '@thinknet-gmbh/platform-common-ui';

import { useGetEmailTemplateById } from 'src/hooks/email-templates/get-email-template-by-id.hook';
import { useUpdateEmailTemplate } from 'src/hooks/email-templates/update-email-template.hook';
import { EmailTemplateForm } from 'src/pages/settings/components/company-settings-pages/email-templates/components/email-template-form';

import { EditWrapper } from './email-template-edit.styles';

const EmailTemplateEdit = ({
  templateId,
  onClose,
}: {
  templateId: string;
  onClose: () => void;
}) => {
  const updateEmailTemplate = useUpdateEmailTemplate({ onSuccess: onClose });

  const { emailTemplate, loading } = useGetEmailTemplateById(templateId);

  const onFinish = (values: any) => {
    updateEmailTemplate({ variables: { payload: { ...values, _id: emailTemplate._id } } });
  };

  if (loading) {
    return <Loader />;
  }

  return (
    <EditWrapper>
      <EmailTemplateForm onClose={onClose} initialValues={emailTemplate} onFinish={onFinish} />
    </EditWrapper>
  );
};

export default EmailTemplateEdit;
